import { JsonObject, JsonValue } from 'type-fest';
import { LSKey } from './local-storage.types';

export const parseStringified = <T extends JsonValue>(
  item: string | null
): T | null => {
  try {
    return JSON.parse(item ?? 'null') as T | null;
  } catch {
    return null;
  }
};
export const retrieveStoredItem = <T extends JsonValue>(
  key: LSKey
): T | null => parseStringified<T>(window.localStorage.getItem(key));

export const storeItem = <T extends JsonValue>(
  key: LSKey,
  item: T
): void =>
  window.localStorage.setItem(
    key,
    JSON.stringify(item !== undefined ? item : null)
  );

export const patchStoredObject = <T extends JsonObject>(
  key: LSKey,
  item: Partial<T>
): Partial<T> => {
  const storedItem =
    retrieveStoredItem<Partial<T>>(key) || ({} as Partial<T>);
  const newItem = {
    ...storedItem,
    ...item,
  };
  storeItem<Partial<T>>(key, newItem);
  return newItem;
};

export const deleteStoredItem = (key: LSKey): void =>
  window.localStorage.removeItem(key);
